// SPDX-License-Identifier: Elastic-2.0
/**
 * Voice API (F-225) — hand-authored gateway calls.
 *
 * Voice shipped after the committed OpenAPI snapshot the generated SDK is
 * built from, so these calls are written by hand against the same
 * low-level `request` core + `OpenAPI` config the generated
 * `*Service.ts` modules use. When the snapshot is regenerated to include
 * `/voice/*`, this module can be replaced by the generated `VoiceService`
 * without touching callers.
 */
import { OpenAPI } from "@/api/gateway/core/OpenAPI";
import { request as __request } from "@/api/gateway/core/request";
import type { CancelablePromise } from "@/api/gateway/core/CancelablePromise";

/** Per-account voice preferences (mirrors `shared.models.voice.VoiceSettings`). */
export interface VoiceSettings {
  wake_phrase: string;
  voice: string;
  language: string;
}

/** Fetch the caller's saved voice settings (defaults if never set). */
export function getVoiceSettings(): CancelablePromise<VoiceSettings> {
  return __request(OpenAPI, {
    method: "GET",
    url: "/voice/settings",
    errors: {
      401: "Unauthorized",
      403: "Forbidden",
      429: "Too Many Requests",
      503: "Service Unavailable",
    },
  });
}

/** Upsert the caller's voice settings. */
export function putVoiceSettings(
  settings: VoiceSettings,
): CancelablePromise<VoiceSettings> {
  return __request(OpenAPI, {
    method: "PUT",
    url: "/voice/settings",
    body: settings,
    mediaType: "application/json",
    errors: {
      401: "Unauthorized",
      403: "Forbidden",
      429: "Too Many Requests",
      503: "Service Unavailable",
    },
  });
}
